export interface MetaPixelParams {
  fbp?: string;
  fbc?: string;
}

export const getMetaPixelParams = (): MetaPixelParams => {
  if (typeof window === "undefined") return {};
  const params = new URLSearchParams(window.location.search);
  const result: MetaPixelParams = {};
  const fbp = params.get("fbp");
  const fbc = params.get("fbc");
  if (fbp) result.fbp = fbp;
  if (fbc) result.fbc = fbc;
  return result;
};
